import { Severity } from '../enums/Severity';

export class SeverityMapper {
  mapSeverity(severity: string | null): Severity {
    switch (severity) {
      case 'HIGH':
        return Severity.HIGH;
      case 'MEDIUM':
        return Severity.MED;
      case 'LOW':
        return Severity.LOW;
      case 'PASSED':
        return Severity.PASSED;
      case 'NA':
        return Severity.NA;
      case 'FILTERED':
        return Severity.FILTERED;
      case 'DISABLED':
        return Severity.DISABLED;
      default:
        return Severity.NO_WARNING;
    }
  }

  mapToGQLSeverity(severity: Severity): string {
    switch (severity) {
      case Severity.HIGH:
        return 'HIGH';
      case Severity.MED:
        return 'MEDIUM';
      case Severity.LOW:
        return 'LOW';
      case Severity.PASSED:
        return 'PASSED';
      case Severity.NA:
        return 'NA';
      case Severity.FILTERED:
        return 'FILTERED';
      case Severity.DISABLED:
        return 'DISABLED';
      default:
        return '';
    }
  }

  mapToSeverityIndex(severity: Severity): number {
    switch (severity) {
      case Severity.HIGH:
        return 4;
      case Severity.MED:
        return 3;
      case Severity.LOW:
        return 2;
      case Severity.PASSED:
        return 1;
      default:
        return 0;
    }
  }
}
